import {
    Box,
    IconButton,
    Typography,
} from '@mui/material';
import { DriverFinancialModel } from '../../models/driverFinancial';
import { ArrowBack } from '@mui/icons-material';
import DetailDriverFinancial from '../driverFinacial/detial';

interface Props {
    onClose: VoidFunction;
    selectedData: DriverFinancialModel[]
}

const RiderReportDetail = ({ onClose, selectedData }: Props) => {

    return (
        <>
            <IconButton onClick={onClose} sx={{ mb: 2 }}>
                <ArrowBack />
            </IconButton>
            {
                selectedData?.map((item, index) => {
                    return <Box sx={{ mb: 2 }} key={index}>
                        <Typography color="red" variant='h4'>ຄັ້ງທີ {index + 1}</Typography>
                        <DetailDriverFinancial disableBackButton={true} onClose={onClose} selectedData={item} onFetchData={() => { }} financialType={null!} />
                    </Box>
                })
            }
        </>
    )
};
export default RiderReportDetail;
